'use client'

import React from "react";
import styles from "./FlyingTextVideo.module.scss";
import { useAOS } from "@/src/lib/hooks/useAOS";

interface FlyingTextVideoProps {
    title: string;
    description: string;
    imageUrl: string;
    videoUrl?: string;
    backgroundColor?: string;
    textColor?: string;
    titleColor?: string;
    buttonColor?: string;
    showButton?: boolean;
    buttonText?: string;
    frameUrl?: string; // ✅ New prop for the fissure frame
}

const FlyingTextVideo: React.FC<FlyingTextVideoProps> = ({
    title,
    description,
    imageUrl,
    videoUrl,
    backgroundColor = "#000000",
    textColor = "#ffffff",
    titleColor = "#FFCC00",
    buttonColor = "#FFD700",
    showButton = false,
    buttonText = "En savoir plus",
    frameUrl,
}) => {
    useAOS();

    return (
        <div className={styles.blockWrapper} style={{ backgroundColor }}>
            <h2 className={styles.title} style={{ color: titleColor }} data-aos='fade-down'>
                {title}
            </h2>
            <div className={styles.gridLayout}>
                <div className={styles.leftSide} style={{ color: textColor }} data-aos='fade'>
                    <div className={styles.textContent}>
                        <p className={styles.description}>{description}</p>
                        {showButton && (
                            <button
                                className={styles.button}
                                style={{
                                    backgroundColor: buttonColor,
                                    color: backgroundColor,
                                }}
                                data-aos='fade-up' data-aos-delay='100'
                            >
                                {buttonText}
                            </button>
                        )}
                    </div>
                </div>
                <div className={styles.rightSide}>
                    <div className={styles.videoWrapper} data-aos='fade-down' data-aos-delay='100'>
                        <video
                            src={`${videoUrl}?autoplay=1&mute=1&rel=0&modestbranding=1&showinfo=0`}
                            title={title}
                            autoPlay
                            muted
                            loop
                            playsInline
                            className={styles.videoFrame}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FlyingTextVideo;
